import { CallsTable } from "./callsData/CallsTable";

export const CallsDataContainer = () => {
  return <CallsTable isUploadButton={true} />;
};

export default CallsDataContainer;
